// extracted by mini-css-extract-plugin
export var quillEditor = "_nh-1";
export var variable = "_nh-0";